<template>
    <div class="story-maker-sticker story-maker-sticker-link">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')">
        <p class="text-finish">{{ $t('dash.post-creator.story.done') }}</p>
        <div class="sticker-link" :class="`style${styleVariant}`">
           <div class="icon"></div>
            <p>{{ text || displayLink }}</p>
        </div>
    </div>
</template>

<script>
    import { isShortLinkUrl, stickerDomainLabel } from '@/utils/composerShortLinks'

    export default {
        props: {
            id: Number | String,
            link: String,
            text: String,
            styleVariant: Number,
            setCbClick: Function,
        },

        computed: {
            // Sans texte, Instagram affiche le domaine du lien en majuscules ; un lien mws.li collé tel quel reste affiché
            // en entier (son domaine d'origine n'est connu qu'à la publication, cf. Lambda stickerLabel)
            displayLink() {
                if (!this.link || isShortLinkUrl(this.link)) return this.link
                return stickerDomainLabel(this.link) || this.link
            }
        },

        mounted () {
            if (this.setCbClick) this.setCbClick(this.changeStyleVariant);
        },
        methods: {
            changeStyleVariant(e) {
                this.$emit('updateSticker',this.id , {
                    data : {
                        link : this.link,
                        text : this.text,
                        styleVariant :(this.styleVariant % 6) + 1
                    },
                })
            }
        },
    }
</script>
